// Vendor
import * as React from 'react';

// Internal
import { ChartConsumersPrioritize } from '@src/charts/ChartConsumersPrioritize';
import { Image } from '@src/components/Image';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

const ConsumersPrioritize: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-xl">
        Consumers Prioritize Value & Online Shopping Over the Next 12 Months
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-description"
      >
        Where shoppers plan to shift their spend in the next 12 months
        <sup>3</sup>
      </p>
      <div className="relative hidden md:block" style={{ height: 350 }}>
        <div className={styles.legend}>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal="fade"
            data-sal-delay={SAL_DELAY * 2}
          >
            Percent of people
            <br />
            who plan to buy
            <br />
            <span
              className="font-bold text-3xl text-brand inline-block"
              style={{ marginTop: -10 }}
            >
              more
            </span>
          </p>
          <p
            {...DEFAULT_SAL_PROPS}
            data-sal="fade"
            data-sal-delay={SAL_DELAY * 3}
          >
            Percent of people
            <br />
            who plan to buy
            <br />
            <span
              className="font-bold text-3xl inline-block"
              style={{ color: '#fdbd55', marginTop: -10 }}
            >
              less
            </span>
          </p>
        </div>
        <ChartConsumersPrioritize />
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal-delay={1000}
          className={styles.callout}
        >
          <div className={styles.triangle} />
          Secondhand, Amazon, and off-price are the only sectors expected to
          gain customers
        </div>
      </div>
      <SlideReveal>
        <Image
          alt="Shoppers plan to shift spending to secondhand Chart"
          addLink={true}
          className="block md:hidden"
          fileName="1h-chart-mobile.png"
        />
      </SlideReveal>
    </div>
  );
};

export { ConsumersPrioritize };
